import axios from "axios"
import { Address, Coordinates, SavedAddress } from "../../types/address"
import axiosClient from "../../utils/axiosClient"
import apiConfig from "constants/apiConfig"

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY

export const getReverseGeocode = async (coords: Coordinates) => {
    const response = await axiosClient.get(`/i/address/geocode?latlng=${coords.latitude},${coords.longitude}`)
    return response.data.results
}

export const fetchPlaces = async (searchQuery: string, coords: Coordinates, type?: string) => {
    const response = await axios.post(apiConfig.FETCH_MAP_PLACES.url, {
        input: searchQuery,
        locationBias: {
            circle: {
                center: coords,
                radius: 500.0
            }
        },
        ...(type ? {type} : {})
    }, {
        headers: {
            'X-Goog-Api-Key': GOOGLE_MAPS_API_KEY
        }
    })

    return response.data.suggestions;

}

export const fetchPlace = async (placeId: string) => {
    const response = await axios.get(apiConfig.FETCH_PLACE.url.replace('<placeId>', placeId), {
        headers: {
            'X-Goog-Api-Key': GOOGLE_MAPS_API_KEY,
            'X-Goog-FieldMask': 'id,location,displayName,name,addressComponents,formattedAddress'
        }
    })

    return response.data;

}
export const storeAddress = async (address: Address) => {
    const response = await axiosClient.post(apiConfig.STORE_ADDRESS.url, address);
    return response.data;
}

export const fetchInfluencerAdresses = async (influencerId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_ADDRESSES.url.replace('<influencerId>', influencerId));
    return response.data.items as SavedAddress[];
}

export const fetchAddress = async (addressId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_ADDRESS.url.replace('<addressId>', addressId));
    return response.data?.address as SavedAddress;
}